/**
 * Created by razial on 14.04.2026.
 */

const SyncedStorage = function () {
    this.keysCache = {};

    cleverapps.dataLoader.listExistingKeys(this.storeKey("")).forEach((storageKey) => {
        this.keysCache[storageKey] = true;
    });
};

SyncedStorage.prototype.storeKey = function (key) {
    return `${DataLoader.TYPES.SYSTORE}_${key}`;
};

SyncedStorage.prototype.addUpdateTask = function () {
    connector.synchronizer.addSendTask("syncedStorage");
};

SyncedStorage.prototype.reset = function () {
    Object.keys(this.keysCache).forEach((storageKey) => {
        cleverapps.dataLoader.remove(storageKey);
    });

    this.keysCache = {};

    this.addUpdateTask();
};

SyncedStorage.prototype.load = function (key) {
    return cleverapps.dataLoader.load(this.storeKey(key));
};

SyncedStorage.prototype.save = function (key, info) {
    const storageKey = this.storeKey(key);

    this.keysCache[storageKey] = true;

    cleverapps.dataLoader.save(storageKey, info);

    this.addUpdateTask();
};

SyncedStorage.prototype.remove = function (key) {
    const storageKey = this.storeKey(key);

    delete this.keysCache[storageKey];

    cleverapps.dataLoader.remove(storageKey);

    this.addUpdateTask();
};

SyncedStorage.prototype.getInfo = function () {
    const serverData = {};

    const prefix = this.storeKey("");

    Object.keys(this.keysCache).forEach((storageKey) => {
        const key = storageKey.replace(prefix, "");
        if (key === storageKey) {
            return;
        }

        serverData[key] = cleverapps.dataLoader.load(storageKey);
    });

    return serverData;
};

SyncedStorage.prototype.updateInfo = function (serverData) {
    Object.keys(this.keysCache).forEach((storageKey) => {
        cleverapps.dataLoader.remove(storageKey);
    });

    this.keysCache = {};

    Object.keys(serverData).forEach((key) => {
        const storageKey = this.storeKey(key);

        this.keysCache[storageKey] = true;

        cleverapps.dataLoader.save(storageKey, serverData[key]);
    });
};
